// cores dos pills — mesma convenção usada em mixQualification.data.js (TIER_BADGE_STYLE)
export const OPPORTUNITY_TYPE_STYLE = {
  "Novo SKU": { color: "#E8773A", bg: "#fff6f0", border: "#fde8d5" },
  "Qualificação de Mix": { color: "#2563eb", bg: "rgba(37,99,235,0.08)", border: "rgba(37,99,235,0.3)" },
  "A verificar": { color: "#999999", bg: "rgba(153,153,153,0.08)", border: "rgba(153,153,153,0.3)" },
};

export const STORE_STATUS_STYLE = {
  ausente: { color: "#d97706", bg: "rgba(217,119,6,0.08)", border: "rgba(217,119,6,0.3)" },
  presente: { color: "#16a34a", bg: "rgba(22,163,74,0.08)", border: "rgba(22,163,74,0.3)" },
};

export const OPPORTUNITY_SUMMARY = {
  totalExpectedGain: 1676003,
  productsAnalyzed: 20,
  newSkuCount: 15,
  mixQualificationCount: 4,
  toVerifyCount: 1,
};

// opções do "Filtrar por status" — value "all" cobre o "Todos (20)"
export const OPPORTUNITY_STATUS_OPTIONS = [
  { value: "all", label: "Todos", count: 20 },
  { value: "Novo SKU", label: "Novo SKU", count: 15 },
  { value: "Qualificação de Mix", label: "Qualificação de Mix", count: 4 },
  { value: "A verificar", label: "A verificar", count: 1 },
];

// mock — troque por chamada de API quando o endpoint existir
export const OPPORTUNITIES = [
  {
    id: 1,
    rank: 1,
    name: "ANDORINHA AZ OLIVA EXT - VIR CM GF VID 500ML",
    roi: 79362,
    group: "Azeites",
    type: "Novo SKU",
    ranking: { rankPoa: 101, poaAnnualValue: 265000, rankCenterShop: 1764, centerShopAnnualValue: 1000, gap: 1663 },
    share: { centerShopSales: 1000, poaSales: 1459000, percentage: 0.006 },
    diagnostic: "Andorinha Extra Virgem é o líder de azeites em POA (#101) mas não consta na CenterShop. A CS vende outros azeites mas não captura a preferência do consumidor de POA.",
    recommendedAction: "Incluir Andorinha Extra Virgem 500ml — produto mais vendido da categoria em POA",
    stores: [
      { id: 1, name: "Loja 1", tier: "Grande", status: "ausente", expectedReturn: 17168 },
      { id: 2, name: "Loja 2", tier: "Média", status: "ausente", expectedReturn: 8079 },
      { id: 3, name: "Loja 3", tier: "Pequena", status: "ausente", expectedReturn: 4697 },
    ],
  },
  {
    id: 2,
    rank: 2,
    name: "ELEGE INTEGRAL S/VERSAO GF PL 1000ML",
    roi: 302538,
    group: "Leite UHT",
    type: "Novo SKU",
    ranking: { rankPoa: 12, poaAnnualValue: 980000, rankCenterShop: 640, centerShopAnnualValue: 15000, gap: 628 },
    share: { centerShopSales: 15000, poaSales: 1459000, percentage: 0.01 },
    diagnostic: "Leite Elege Integral está entre os mais vendidos em POA mas tem baixa penetração na CenterShop.",
    recommendedAction: "Incluir Elege Integral 1L — alta rotatividade em POA",
    stores: [
      { id: 1, name: "Loja 1", tier: "Grande", status: "ausente", expectedReturn: 60508 },
    ],
  },
  {
    id: 3,
    rank: 3,
    name: "POLAR EXPORT LAGER CL C/ALC LT 12X473ML PACK ECO",
    roi: 145382,
    group: "Cerveja",
    type: "Novo SKU",
    ranking: { rankPoa: 34, poaAnnualValue: 610000, rankCenterShop: 890, centerShopAnnualValue: 22000, gap: 856 },
    share: { centerShopSales: 22000, poaSales: 1459000, percentage: 0.015 },
    diagnostic: "Polar Export é uma das cervejas mais vendidas em POA mas quase não aparece na CenterShop.",
    recommendedAction: "Incluir Polar Export pack 12x473ml — forte giro em POA",
    stores: [
      { id: 1, name: "Loja 1", tier: "Grande", status: "ausente", expectedReturn: 90200 },
      { id: 2, name: "Loja 2", tier: "Média", status: "ausente", expectedReturn: 55182 },
    ],
  },
  {
    id: 4,
    rank: 4,
    name: "OE MIMMO FD NEUTRO LV12 PG11 30M",
    roi: 60199,
    group: "Papel Higiênico",
    type: "Novo SKU",
    ranking: { rankPoa: 58, poaAnnualValue: 320000, rankCenterShop: 1200, centerShopAnnualValue: 8000, gap: 1142 },
    share: { centerShopSales: 8000, poaSales: 1459000, percentage: 0.005 },
    diagnostic: "OE Mimmo neutro tem boa saída em POA e não está presente na maioria das lojas CenterShop.",
    recommendedAction: "Incluir OE Mimmo folha dupla 12 rolos",
    stores: [
      { id: 1, name: "Loja 3", tier: "Pequena", status: "ausente", expectedReturn: 60199 },
    ],
  },
  {
    id: 5,
    rank: 5,
    name: "NESTLE NAPOLITANO TRADICIONAL POTE 710G/1500ML",
    roi: 65379,
    group: "Sorvetes",
    type: "Novo SKU",
    ranking: { rankPoa: 41, poaAnnualValue: 410000, rankCenterShop: 980, centerShopAnnualValue: 9500, gap: 939 },
    share: { centerShopSales: 9500, poaSales: 1459000, percentage: 0.007 },
    diagnostic: "Sorvete Napolitano é um dos mais vendidos em POA, mas a CenterShop trabalha só com outras marcas.",
    recommendedAction: "Incluir Napolitano 1,5L — sabor mais vendido da categoria",
    stores: [
      { id: 1, name: "Loja 1", tier: "Grande", status: "ausente", expectedReturn: 40200 },
      { id: 2, name: "Loja 6", tier: "Média", status: "ausente", expectedReturn: 25179 },
    ],
  },
  {
    id: 6,
    rank: 6,
    name: "PEPSI TWIST BX CALORIA COLA P DESC 2000 ML",
    roi: 75765,
    group: "Refri Cola",
    type: "Novo SKU",
    ranking: { rankPoa: 22, poaAnnualValue: 540000, rankCenterShop: 710, centerShopAnnualValue: 14000, gap: 688 },
    share: { centerShopSales: 14000, poaSales: 1459000, percentage: 0.01 },
    diagnostic: "Pepsi Twist 2L tem forte saída em POA e baixa presença na CenterShop.",
    recommendedAction: "Incluir Pepsi Twist 2L nas lojas de maior porte",
    stores: [
      { id: 1, name: "Loja 2", tier: "Média", status: "ausente", expectedReturn: 75765 },
    ],
  },
  {
    id: 7,
    rank: 7,
    name: "MOCA TRAD NATURAL SEMI DESN CART 395G",
    roi: 71794,
    group: "Leite Condensado",
    type: "Novo SKU",
    ranking: { rankPoa: 19, poaAnnualValue: 500000, rankCenterShop: 655, centerShopAnnualValue: 13000, gap: 636 },
    share: { centerShopSales: 13000, poaSales: 1459000, percentage: 0.009 },
    diagnostic: "Leite condensado Moça é líder de categoria em POA e vende pouco na CenterShop.",
    recommendedAction: "Incluir Moça 395g em todas as lojas médias e grandes",
    stores: [
      { id: 1, name: "Loja 1", tier: "Grande", status: "ausente", expectedReturn: 71794 },
    ],
  },
  {
    id: 8,
    rank: 8,
    name: "STELLA ARTOIS PUREGOLD LAGER PURO MALTE CL C/ALC V DESC",
    roi: 222331,
    group: "Cerveja Premium",
    type: "Novo SKU",
    ranking: { rankPoa: 15, poaAnnualValue: 730000, rankCenterShop: 520, centerShopAnnualValue: 26000, gap: 505 },
    share: { centerShopSales: 26000, poaSales: 1459000, percentage: 0.018 },
    diagnostic: "Stella Artois puro malte cresce em POA e tem presença fraca na CenterShop.",
    recommendedAction: "Incluir Stella Artois vasilhame com retorno de embalagem",
    stores: [
      { id: 1, name: "Loja 1", tier: "Grande", status: "ausente", expectedReturn: 130000 },
      { id: 2, name: "Loja 2", tier: "Média", status: "ausente", expectedReturn: 92331 },
    ],
  },
  {
    id: 9,
    rank: 9,
    name: "SANTA MASSA S/RECH TRAD 400G",
    roi: 115327,
    group: "Massas",
    type: "Novo SKU",
    ranking: { rankPoa: 27, poaAnnualValue: 590000, rankCenterShop: 780, centerShopAnnualValue: 17000, gap: 753 },
    share: { centerShopSales: 17000, poaSales: 1459000, percentage: 0.012 },
    diagnostic: "Massa Santa Massa é referência em POA e tem baixa cobertura na CenterShop.",
    recommendedAction: "Incluir Santa Massa tradicional 400g",
    stores: [
      { id: 1, name: "Loja 3", tier: "Pequena", status: "ausente", expectedReturn: 115327 },
    ],
  },
  {
    id: 10,
    rank: 10,
    name: "QUALY MIX ORIGINAL POTE 500G",
    roi: 42150,
    group: "Margarina",
    type: "Novo SKU",
    ranking: { rankPoa: 63, poaAnnualValue: 260000, rankCenterShop: 1310, centerShopAnnualValue: 6000, gap: 1247 },
    share: { centerShopSales: 6000, poaSales: 1459000, percentage: 0.004 },
    diagnostic: "Qualy Mix original tem boa saída em POA e não é vendida na CenterShop.",
    recommendedAction: "Incluir Qualy Mix 500g nas lojas médias",
    stores: [
      { id: 1, name: "Loja 6", tier: "Média", status: "ausente", expectedReturn: 42150 },
    ],
  },
  {
    id: 11,
    rank: 11,
    name: "YOKI FARINHA DE MANDIOCA TORRADA 500G",
    roi: 38920,
    group: "Farináceos",
    type: "Novo SKU",
    ranking: { rankPoa: 71, poaAnnualValue: 210000, rankCenterShop: 1420, centerShopAnnualValue: 5000, gap: 1349 },
    share: { centerShopSales: 5000, poaSales: 1459000, percentage: 0.003 },
    diagnostic: "Farinha de mandioca Yoki tem demanda constante em POA e cobertura baixa na CenterShop.",
    recommendedAction: "Incluir Yoki farinha torrada 500g",
    stores: [
      { id: 1, name: "Loja 7", tier: "Média", status: "ausente", expectedReturn: 38920 },
    ],
  },
  {
    id: 12,
    rank: 12,
    name: "HEINZ KETCHUP TRADICIONAL 397G",
    roi: 51230,
    group: "Molhos",
    type: "Novo SKU",
    ranking: { rankPoa: 46, poaAnnualValue: 300000, rankCenterShop: 990, centerShopAnnualValue: 8500, gap: 944 },
    share: { centerShopSales: 8500, poaSales: 1459000, percentage: 0.006 },
    diagnostic: "Ketchup Heinz é o mais vendido da categoria em POA e tem baixa penetração na CenterShop.",
    recommendedAction: "Incluir Heinz tradicional 397g",
    stores: [
      { id: 1, name: "Loja 9", tier: "Média", status: "ausente", expectedReturn: 51230 },
    ],
  },
  {
    id: 13,
    rank: 13,
    name: "ADES ORIGINAL SOJA 1L",
    roi: 47680,
    group: "Bebidas Vegetais",
    type: "Novo SKU",
    ranking: { rankPoa: 54, poaAnnualValue: 280000, rankCenterShop: 1105, centerShopAnnualValue: 7200, gap: 1051 },
    share: { centerShopSales: 7200, poaSales: 1459000, percentage: 0.005 },
    diagnostic: "Ades original tem crescimento constante em POA e cobertura baixa na CenterShop.",
    recommendedAction: "Incluir Ades original 1L",
    stores: [
      { id: 1, name: "Loja 10", tier: "Média", status: "ausente", expectedReturn: 47680 },
    ],
  },
  {
    id: 14,
    rank: 14,
    name: "OMO LAVA ROUPAS LIQUIDO 3L",
    roi: 88410,
    group: "Limpeza",
    type: "Novo SKU",
    ranking: { rankPoa: 31, poaAnnualValue: 470000, rankCenterShop: 820, centerShopAnnualValue: 12500, gap: 789 },
    share: { centerShopSales: 12500, poaSales: 1459000, percentage: 0.009 },
    diagnostic: "Omo líquido 3L é líder de categoria em POA com baixa presença na CenterShop.",
    recommendedAction: "Incluir Omo líquido 3L nas lojas de maior porte",
    stores: [
      { id: 1, name: "Loja 12", tier: "Média", status: "ausente", expectedReturn: 88410 },
    ],
  },
  {
    id: 15,
    rank: 15,
    name: "COLGATE TOTAL 12 90G",
    roi: 33210,
    group: "Higiene Bucal",
    type: "Novo SKU",
    ranking: { rankPoa: 68, poaAnnualValue: 195000, rankCenterShop: 1380, centerShopAnnualValue: 4200, gap: 1312 },
    share: { centerShopSales: 4200, poaSales: 1459000, percentage: 0.003 },
    diagnostic: "Colgate Total 12 tem boa saída em POA e presença baixa na CenterShop.",
    recommendedAction: "Incluir Colgate Total 12 90g",
    stores: [
      { id: 1, name: "Loja 14", tier: "Média", status: "ausente", expectedReturn: 33210 },
    ],
  },
  {
    id: 16,
    rank: 16,
    name: "AURORA LINGUICA CALABRESA 500G",
    roi: 28900,
    group: "Frios",
    type: "Qualificação de Mix",
    ranking: { rankPoa: 82, poaAnnualValue: 150000, rankCenterShop: 260, centerShopAnnualValue: 45000, gap: 178 },
    share: { centerShopSales: 45000, poaSales: 1459000, percentage: 0.031 },
    diagnostic: "Linguiça Aurora já está presente na CenterShop, mas com giro abaixo do potencial de POA.",
    recommendedAction: "Reforçar exposição de Aurora calabresa 500g",
    stores: [
      { id: 1, name: "Loja 1", tier: "Grande", status: "presente", expectedReturn: 28900 },
    ],
  },
  {
    id: 17,
    rank: 17,
    name: "SADIA PEITO DE PERU FATIADO 200G",
    roi: 19540,
    group: "Frios",
    type: "Qualificação de Mix",
    ranking: { rankPoa: 95, poaAnnualValue: 110000, rankCenterShop: 340, centerShopAnnualValue: 31000, gap: 245 },
    share: { centerShopSales: 31000, poaSales: 1459000, percentage: 0.021 },
    diagnostic: "Peito de peru Sadia já está no mix, mas com espaço para crescer frente ao consumo de POA.",
    recommendedAction: "Ampliar espaço de gôndola de Sadia fatiados",
    stores: [
      { id: 1, name: "Loja 2", tier: "Média", status: "presente", expectedReturn: 19540 },
    ],
  },
  {
    id: 18,
    rank: 18,
    name: "TIO JOAO ARROZ TIPO 1 5KG",
    roi: 64200,
    group: "Arroz",
    type: "Qualificação de Mix",
    ranking: { rankPoa: 8, poaAnnualValue: 890000, rankCenterShop: 95, centerShopAnnualValue: 210000, gap: 87 },
    share: { centerShopSales: 210000, poaSales: 1459000, percentage: 0.144 },
    diagnostic: "Tio João 5kg já é forte na CenterShop, mas ainda abaixo da relevância que tem em POA.",
    recommendedAction: "Revisar ponto de exposição e preço de Tio João 5kg",
    stores: [
      { id: 1, name: "Loja 1", tier: "Grande", status: "presente", expectedReturn: 64200 },
    ],
  },
  {
    id: 19,
    rank: 19,
    name: "CAMIL FEIJAO CARIOCA 1KG",
    roi: 31870,
    group: "Feijão",
    type: "Qualificação de Mix",
    ranking: { rankPoa: 25, poaAnnualValue: 520000, rankCenterShop: 210, centerShopAnnualValue: 89000, gap: 185 },
    share: { centerShopSales: 89000, poaSales: 1459000, percentage: 0.061 },
    diagnostic: "Feijão Camil 1kg tem boa presença na CenterShop, mas participação abaixo do ideal frente a POA.",
    recommendedAction: "Reforçar reposição de Camil feijão carioca 1kg",
    stores: [
      { id: 1, name: "Loja 3", tier: "Pequena", status: "presente", expectedReturn: 31870 },
    ],
  },
  {
    id: 20,
    rank: 20,
    name: "NATURA TODO DIA SABONETE 85G",
    roi: 12300,
    group: "Higiene Pessoal",
    type: "A verificar",
    ranking: { rankPoa: 120, poaAnnualValue: 60000, rankCenterShop: 2100, centerShopAnnualValue: 900, gap: 1980 },
    share: { centerShopSales: 900, poaSales: 1459000, percentage: 0.0006 },
    diagnostic: "Dados de venda de Natura Todo Dia ainda inconsistentes entre as bases de POA e CenterShop.",
    recommendedAction: "Validar cadastro e histórico de vendas antes de decidir inclusão",
    stores: [
      { id: 1, name: "Loja 1", tier: "Grande", status: "ausente", expectedReturn: 12300 },
    ],
  },
];
